RivalIQ.apps.AdsInsights.module('views', function (views, App, Backbone, Marionette, $, _, s) {

    'use strict';

    views.SecondaryNavigation = RivalIQ.views.LayoutView.mixin({
        getTemplate: function () {
            const me = this;

            if (me.isEmptyAdObject()) {
                return '#adsSecondaryNavigationEmpty';
            } else {
                return '#adsSecondaryNavigation';
            }
        },

        className: 'ad-secondary-navigation',

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        dashboardModelEvents: {
            'change': 'reload'
        },

        regions: {
            breadcrumbs: '.x-breadcrumbs'
        },

        ui: {
            information: '.fa-info-circle'
        },

        isEmptyAdObject: function () {
            const me = this;
            return !_.has(me.adObject, 'account_id');
        },

        onRenderLoaded: function () {
            const me = this;

            if (!me.isEmptyAdObject()) {
                me.showBreadcrumbs();
            }

            me.ui.information.popover();
        },

        showBreadcrumbs: function () {
            const me = this;

            const adObject = me.adObject;

            const breadcrumbs = new App.views.Breadcrumbs({
                dashboardModel: me.dashboardModel,
                adObject: adObject
            });

            me.breadcrumbs.show(breadcrumbs);
        },

        serializeData: function () {
            const me = this;

            if (me.isEmptyAdObject()) {
                return {};
            }

            let objective = _.get(RivalIQ.enums.facebookAdCampaignObjectives, [me.adObject.objective, 'name'], me.adObject.objective);
            let objectiveDescription = null;

            if (objective === 'MULTIPLE') {
                objective = RivalIQ.strings.facebook_ads_insights_multple_objectives_name;
                objectiveDescription = RivalIQ.strings.facebook_ads_insights_multple_objectives_description;
            }

            const boostedPostData = me.adObject.boostedPostData;
            let rivalIqPostLink = null;

            if (boostedPostData && boostedPostData.company_id && boostedPostData.id) {
                const router = me.dashboardModel.router;

                const detailsProps = {
                    companyId: boostedPostData.company_id,
                    postId: boostedPostData.id
                };

                rivalIqPostLink = router.resolveCurationRoute(RivalIQ.enums.curation.FACEBOOK_INSIGHTS_POST_DETAILS, detailsProps);
            }

            return _.defaults({
                editLink: App.utils.constructNativeLink(me.adObject),
                objective: objective,
                objectiveDescription: objectiveDescription,
                rivalIqPostLink: rivalIqPostLink
            }, me.adObject);
        },

        templateHelpers: function () {
            return _.extend({
                s: s
            }, RivalIQ.utils.emoji.getTemplateHelpers());
        },

        loadData: function () {
            const me = this;

            return App.utils.fetchAdObject(me.getProps())
                .then(function (adObject) {
                    me.adObject = adObject;
                });
        }
    });

}, window.s);
